import { render, staticRenderFns } from "./echart.vue?vue&type=template&id=45832a54"
import script from "./echart.vue?vue&type=script&lang=js"
export * from "./echart.vue?vue&type=script&lang=js"
import style0 from "./echart.vue?vue&type=style&index=0&id=45832a54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports